import { useEffect, useMemo, useRef, useState } from 'react'
import debounce from 'lodash/debounce'

import useDispatch from 'hooks/useDispatch'
import { updateFilters } from '../../../../../actions/searchActions'
import Input from '../../../common/AvailableWeekends'

type Props = {
  filters: GQL_SearchFilters
}

const useSelectedValuesState = (filters: GQL_SearchFilters) => {
  const initialValues = filters?.weekendMonths || []
  const updatedOnce = useRef(false)
  const [selectedValues, setSelectedValues] = useState(initialValues)

  useEffect(() => {
    if (updatedOnce.current === false && initialValues.length > 0) {
      setSelectedValues(initialValues)
      updatedOnce.current = true
    }
  }, [initialValues.toString()])

  return [selectedValues, setSelectedValues] as const
}

const AvailableWeekends = ({ filters }: Props) => {
  const dispatch = useDispatch()

  const [selectedValues, setSelectedValues] = useSelectedValuesState(filters)

  const debouncedUpdate = useMemo(
    () =>
      debounce((values: string[]) => {
        dispatch(
          updateFilters({
            weekendMonths: values,
          })
        )
      }, 500),
    [dispatch]
  )

  const handleChange = ({
    checked,
    value,
  }: {
    checked: boolean
    value: string
  }) => {
    let weekendMonths: string[]

    if (checked) {
      const next = [...selectedValues, value]
      setSelectedValues(next)
      weekendMonths = next
    } else {
      const next = selectedValues.filter((v) => v !== value)
      setSelectedValues(selectedValues.filter((v) => v !== value))
      weekendMonths = next
    }

    debouncedUpdate(weekendMonths)
  }

  return <Input selectedValues={selectedValues} onChange={handleChange} />
}

export default AvailableWeekends
